import React from "react";
import styled from 'styled-components';

const Timer = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 20px auto 0;
  padding: 20px;
  background-color: #f8f9fa;
  font-weight: bolder;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;

  div {
    text-align: center;
  }

  .watch {
    color: #5C2D91;
    display: block;
    font-size: 2rem;
  }

  h4 {
    color: #666;
    font-size: 0.85rem;
    margin: 4px 0 0;
  }

`;

const TimerUp = ({ running = true }) => {
    const [countDown, setCountDown] = React.useState(0);
    
    React.useEffect(() => {
      let timerId;
    //   console.log(until)
  
      if (running) {
        // setCountDown(60 * until);
        timerId = setInterval(() => {
          setCountDown((countDown) => countDown + 1);
        }, 1000);
      } else {
        clearInterval(timerId);
      }
  
      return () => clearInterval(timerId);
    }, [running]);
  
  //  const togglerTimer = () => setRunTimer((t) => !t);
  
    const seconds = String(countDown % 60).padStart(2, 0);
    const minutes = String(Math.floor((countDown / 60) % 60)).padStart(2, 0);
    const hours = String(Math.floor(countDown / (60*60))).padStart(2, 0);
    
    // if (seconds == 60) {
    //   minutes = minutes + 1;
    //   seconds = 0;
    // }
    // if (minutes == 60) {
    //   hours = hours + 1;
    //   minutes = 0;
    //   seconds = 0;
    // }
    
  
    return (
      <div className="App">
        <Timer>

        <div>
   
   <span className='watch'>{hours}</span>
  <h4>hours</h4>
</div>
        
      <div>
   
           <span className='watch'>{minutes}</span>
          <h4>minutes</h4>
      </div>
       <div>
          <span className='watch'>{seconds}</span> 
          <h4>seconds</h4>
       </div>
         
        </Timer>
  
        {/* <button type="button" onClick={togglerTimer}>
          {runTimer ? "Stop" : "Start"}
        </button> */}
      </div>
    );
  }
  export default TimerUp;
